var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.TooltipProviderWowhead.item(_vm.item.item.id)}},[_c('img',{class:("gear-icon icon game " + (_vm.stringUtils.getItemColor(_vm.item.quality.type))),attrs:{"src":_vm.item.media.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }